import css from "./TwoColumn.module.scss";

export default function TwoColumn({ colLeft, colRight, colRightStyles, colLeftStyles, layoutStyles }) {
   return (
      <div className={css.layout} style={layoutStyles}>
         <div className={css.col + " " + css["col--left"]} style={colLeftStyles}>
            {colLeft}
         </div>
         <div className={css.col + " " + css["col--right"]} style={colRightStyles}>
            {colRight}
         </div>
      </div>
   );
}
